import React from "react";

import { InjectedContentBlock } from "@utils/search/@types/internal/injectedContentBlock";

type ContentBlockComponentProps = {
    content: InjectedContentBlock;
};

export const ContentBlockComponent = ({
    content,
}: ContentBlockComponentProps) => (
    <span className={"contentBlock__contents__wrapper"}>
        {content.imageUrl && (
            <img
                src={content.imageUrl}
                alt={content.title}
                data-sizes="auto"
                data-src={content.imageUrl}
            />
        )}
        {content.title && (
            <h5 className={"text-primary clamp-2"}>{content.title}</h5>
        )}
        {content.description && <p className="mb-0">{content.description}</p>}
    </span>
);
